<template>
    <div>
        <p class="fs-20 text-center">Ao clicar em <span class="text-danger">"CONFIRMAR"</span>, seu aplicativo customizado  será enviado a equipe Constr Up 
        para disponiliza-lo nas lojas Google Play e Apple Store. Esse processo pode levar até 30 dias corridos, e te informaremos quando 
        seu app estiver pronto para download.</p>

        <span class="btn btn-success d-flex justify-content-center text-uppercase mt-5" @click="sendRequestApp()">Confirmar</span>
    </div>
</template>
<script>
import modal from '../mixins/modal';
import { mapState } from 'vuex';
export default {
    mixins: [modal],
    emits: ['validModal'],
    data() {
        return {
            lojista: {
                id_lojista: null,
                app: 4
            }
        }
    },

    computed: {
        ...mapState(['token', 'dadosUsuario']),
    },

    methods: {
        sendRequestApp() {
            this.lojista.id_lojista = this.dadosUsuario.informacoes.id;
            this.$store.dispatch('startLoader');
            this.$store
            .dispatch('sendShopkeeperData', this.lojista)
            .then(() => {
                this.$bvModal.hide('availableApp');
                this.$store.dispatch('endLoader');
                this.$emit('validModal')
            })
            .catch(() => {
            const self = this;
            this.$store.dispatch('endLoader');
            self.notificationPopup('Ocorreu um erro, tente novamente!', 'warning');
        })
    }
},

mounted() {
        let myStorage = this.id_lojista = this.dadosUsuario.informacoes.usuario_id;
        let myLocal = localStorage.setItem('id_lojista', myStorage);
        if(myLocal != this.dadosUsuario.informacoes.usuario_id) {
            myLocal = localStorage.setItem('id_lojista', myStorage);
        }
    }
}
</script>